import { CI_DATABASES } from '@Services/UserDatabases/UserDatabasesConstants';
import DruglikenessComponent from './DruglikenessComponent';
import CustomDruglikenessComponent from './CustomDruglikenessComponent';

export const initialize = (response, databaseId) => {
  if (CI_DATABASES.indexOf(databaseId) !== -1) {
    return new CustomDruglikenessComponent(response, databaseId);
  }
  return new DruglikenessComponent(response, databaseId);
};

export default initialize;
